import elementCreation from '../elementCreation';

class RebatesBodyComponent {
    constructor(rebatesBodyContainer, emitter) {
        this.rebatesBodyContainer = rebatesBodyContainer;
        this.rebatesTab = document.querySelector('.payment-details__nav-containers.rebates');
        this.emitter = emitter;
        this.vehicleState;
        this.rebates;
        this.selectedPaymentType;
        this.selectedOffer;

        this.emitter.on('new-vehicle-state', (vehicleState) => {
            this.init(vehicleState);
        });

    }

    init(vehicleState) {
        this.vehicleState = vehicleState;
        this._setState(vehicleState.payments ? vehicleState : {payments: {...vehicleState}});
        this._handleRebates();
    }

    _setState(vehicleState) {
        if (vehicleState && vehicleState.payments && vehicleState.payments.selected) {
            this.selectedPaymentType = vehicleState.payments.selected;
            if (this._hasOffers(vehicleState.payments[this.selectedPaymentType])) {
                this.selectedOffer = vehicleState.payments[this.selectedPaymentType].selected_offer;
                this.rebates = vehicleState.payments[this.selectedPaymentType].offers[this.selectedOffer].rebates;
            } else {
                this.rebates = null;
            }
        }
    }

    _hasOffers(payment) {
        if (payment.offers && payment.offers[0]) {
            return true;
        } else {
            return false;
        }
    }

    _handleRebates() {
        const rebateString = elementCreation.rebatesContainer(this.rebates);
        this.rebatesBodyContainer.innerHTML = rebateString;
    }
}

export default RebatesBodyComponent;